import {AfterViewInit, Component, OnInit, ViewChild, ViewEncapsulation} from '@angular/core';
import {language} from '../../../language/vn';
import { FormBuilder} from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import {CommandUtil} from '../../../global/commandutil';
import {BsModalService} from 'ngx-bootstrap/modal';
import {environment} from '../../../../environments/environment';
import {ConfirmDialogComponent} from '../../dialog/confirmdialog.component';
import {GroupUserDefine} from '../../../models/staff/groupuserdefine';
import {GroupUserDefineService} from '../../../service/staff/service-groupuserdefine';
import {EditRolesComponent} from './edit.component';
import {PermissionsComponent} from './permission.component';
import {DSPermissionsComponent} from './dsp.component';
import {DSStaffsPermissionsComponent} from './st.component';


@Component({
  templateUrl: './role.component.html',
  encapsulation: ViewEncapsulation.None
})
export class RolesComponent implements OnInit, AfterViewInit {
  public language = language;
  public totalItems: number = 0;
  public hoSoId:  number;
  public currentPage: number   = environment.currentPage;
  public maxSize: number = environment.pageMaxRecord;
  public numPages: number = environment.numberPages;
  public defaultValue: string[]=["-1"];
  public dataList: GroupUserDefine[];
  public srKeyword: string = '';

  constructor( public groupUserDefineService: GroupUserDefineService,
               public formBuilder: FormBuilder,
               public toastr: ToastrService,
               public bsModalService: BsModalService


  ) {
  }
  ngAfterViewInit() {

  }
  ngOnInit(): void {


    this.search();
  }
  search()
  {
    this.groupUserDefineService.findAllByPaging(this.srKeyword,  this.currentPage, this.maxSize).subscribe(dataList => this.dataList = dataList);
    this.groupUserDefineService.getCountByKeyword(this.srKeyword).subscribe(recordCount => this.totalItems = recordCount);
  }
  public showConfirmationModal(id: number): void {
    const modal = this.bsModalService.show(ConfirmDialogComponent);
    (<ConfirmDialogComponent>modal.content).showConfirmationModal(
      language.message,
      language.confirm_delete_question,
      language.yes,
      language.no
    );
    (<ConfirmDialogComponent>modal.content).onClose.subscribe(result => {
      if (result === true) {
          this.deleteItem(id);
      }
    });
  }
  public deleteItem(id: number)
  {
    this.groupUserDefineService.delete(id).subscribe({
      next: () => {
        this.toastr.success(language.delete_success_record, language.message);
        this.search();


      },
      error: error => {
        this.toastr.error(language.error, language.message);
      }
    });
  }
  public edit(id: number): void {
    const modalEdit = this.bsModalService.show(EditRolesComponent, {class: 'modal-xl', keyboard: false, backdrop: 'static'});
    (<EditRolesComponent>modalEdit.content).edit(
      id

    );
    (<EditRolesComponent>modalEdit.content).onClose.subscribe(result => {
      if (result === true) {
        this.search();

      }
    });
  }
  public permision(id: number): void {
    const modalEdit = this.bsModalService.show(DSPermissionsComponent, {class: 'modal-xl', keyboard: false, backdrop: 'static'});
    (<DSPermissionsComponent>modalEdit.content).show(
      id

    );
    (<DSPermissionsComponent>modalEdit.content).onClose.subscribe(result => {
      if (result === true) {
        this.search();

      }
    });
  }
  public selectStaffs(id: number): void {
    const modalEdit = this.bsModalService.show(DSStaffsPermissionsComponent, {class: 'modal-xl', keyboard: false, backdrop: 'static'});
    (<DSStaffsPermissionsComponent>modalEdit.content).show(
      id

    );
    (<DSStaffsPermissionsComponent>modalEdit.content).onClose.subscribe(result => {
      if (result === true) {
        this.search();

      }
    });
  }
  pageChanged(event: any): void {
    this.currentPage = event.page;
    this.search();

  }

}

